import { createContext } from 'react';

const downlinkContext = createContext();

export default downlinkContext;